import React, { useEffect, useState } from 'react'
import { Box, Card, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import deleteIcon from "../../assest/icons/delete.svg";
import restoreIcon from "../../assest/icons/restore.svg";
import editIcon from "../../assest/icons/edit.svg";
import ViewIcon from "../../assest/icons/viewIcon.svg";
import CardCustom from '../common/card';
import { useDispatch, useSelector } from 'react-redux';
import { getArticles, statusUpdateArticle } from '../../redux/actions/KnowledgeBase/article';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from "./../common2/Breadcrumbs";
import TopFilter from '../common2/TopFilter';
import { IState } from '../../redux/reducers/rootReducers';
function ArticleList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [DummyList, setDummyList] = useState([]);
    const [permissionInfo, setpermissionInfo] = useState({}as any);
    const [listStatus, setListStatus] = useState(true);
    const [seachData, setSearchData] = useState("");
    const [checked, setChecked] = useState(false);
    const rolesAccess = useSelector((state: IState) => state?.LoginReducer?.roleAccess);

    useEffect(()=>{
        getArticlesApi();
    },[])
    useEffect(() => {
        if(rolesAccess){
          console.log('rolesAccess.Contacts',rolesAccess.Contacts)
          setpermissionInfo({...rolesAccess.Article, isSuperAdmin: rolesAccess.isSuperAdmin})
        }
    }, [rolesAccess]);

    const getArticlesApi = () => {
        dispatch(getArticles(getCallback))
    }
    const getCallback = (resStatus:string,res:any)=>{
        if(resStatus==="0"){
            setList(res);
        }
    }
    const handleSearch = (e: any) => {
        let lowerCase = e.target.value;
        setSearchData(lowerCase);
    };
    const filterHandler = (e: any) => {
        // setListStatus(e)
    };
    const checkBoxHandler = (e: any, id: any) => {};
    const showDataHandler = (show: boolean) => {
        setListStatus(show)
        console.log('0987654',show)
    };
    const updateAllHandler = (value: any, id: any) => {};
    const addArticleTypeHandler = () => {};
    const statusChangeHandler = (id:number,statusToChange:boolean) =>{
        dispatch(statusUpdateArticle(id,statusToChange, getArticlesApi));
    }

    const checkPermission:any = (valueKey:string) =>{
        let val:boolean = permissionInfo[valueKey] ? true : false
        return val;
    }
    return (
        <Box className="p-1">
            <Breadcrumbs
                data={[
                    {
                        title: 'Knowledge Base ',
                        path: '/KnowledgeBase'
                    },
                    {
                        title: 'Article List ',
                        path: '/ArticlesList'
                    }
                ]
                }
            />
            <TopFilter
                path='/createArticle'
                Data={DummyList}
                SearchHandler={handleSearch}
                value={seachData}
                filterHandler={filterHandler}
                checkBoxHandler={checkBoxHandler}
                checked={checked}
                filterItems={showDataHandler}
                updateAllHandler={updateAllHandler}
                //bulkDeleteHandler={bulkDeleteHandler}
                hideSelectAllOption={true}
                titleState={listStatus}
                addHandler={addArticleTypeHandler}
                pathname={"/articlesList"}
                temp={DummyList}
                redirectTo="/KnowledgeBase"
                placeHolder='Search Articles'
                inActiveLabel = "In-Active"
                activeLabel = "Active"
                hideAddBtn = {checkPermission('Create') || checkPermission('isSuperAdmin') ? false : true}
            />
            <Grid container className='pt-1' spacing={1}>
                {list.map((i: any, index: number) => {
                    const objVals = `${Object.values(i)}`.toLowerCase();
                    const { isActive,name,id,keywords } = i;
                    return (
                        <React.Fragment key={index}>
                            {(listStatus === isActive && objVals.indexOf(`${seachData}`.toLowerCase()) >= 0) && 
                                <Grid item xs={12} md={3}>
                                    <CardCustom
                                        customHeader={
                                            <Typography>
                                                {/* ID : {id} */}
                                                {name}
                                            </Typography>
                                        }
                                        cardBody={
                                            <Box>
                                                <>
                                                    <Box>
                                                        <Typography variant='body1' className="medium-title">
                                                            ID : {id}
                                                        </Typography>
                                                        <hr/>
                                                        <Typography variant='body2' sx={{fontSize:'12px !important'}}>Keywords : {keywords}</Typography>
                                                    </Box>
                                                </>
                                            </Box>
                                        }
                                        cardFooter={
                                            <Box>
                                                <Box>
                                                    <Tooltip title={`View`}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={()=>{
                                                                navigate(`/ViewArticle/${id}`)
                                                            }}
                                                        >
                                                            <img src={ViewIcon} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {permissionInfo && (checkPermission('Edit') || checkPermission('isSuperAdmin')) && isActive  && (
                                                        <Tooltip title={`Edit`}>
                                                            <IconButton
                                                                // disabled={isActive ? false : true}
                                                                size="small"
                                                                onClick={()=>{
                                                                    navigate(`/ArticlesList/${id}`)
                                                                }}
                                                            >
                                                                <img src={editIcon} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}

                                                    {(checkPermission('isSuperAdmin') || (!isActive && checkPermission('ReActivate'))  || (isActive && checkPermission('DeActivate'))) && 
                                                        <Tooltip title={`${isActive? "Delete" : "Restore"}`}>
                                                            <IconButton
                                                                size="small"
                                                                onClick={(e: any) => { statusChangeHandler(id,!isActive) }}
                                                            >
                                                                <img src={isActive ? deleteIcon : restoreIcon} />
                                                            </IconButton>
                                                        </Tooltip> 
                                                    }
                                                </Box>
                                            </Box>
                                        }
                                    />
                                </Grid>
                            }
                        </React.Fragment>)
                })}
            </Grid>
        </Box>
    )
}

export default ArticleList;
